export default {
  "ltv.title": "LTV",
  "ltv.column.no": "#序号",
  "ltv.column.statisticsTime": "日期",
  "ltv.column.registerNum": "注册人数",
  "ltv.column.ltv1": "LTV1",
  "ltv.column.ltv3": "LTV3",
  "ltv.column.ltv7": "LTV7",
  "ltv.column.ltv14": "LTV14",
  "ltv.column.ltv30": "LTV30",
  "ltv.search.statisticsTime": "日期",
};